// extracted by mini-css-extract-plugin
module.exports = {"bgConfetti":"team_bgConfetti__8WwVC"};